import VBaiduMap from './vmap'
export default VBaiduMap
